import { AppointmentSelectOption } from '../model/estimate'

export interface PhysicianSelectionAppointment {
  id: string
  referrerId?: string | null
  referringPhysicianId?: string | null
  attendingPhysicianId?: string | null
  orderingPhysicianId?: string | null
}

/**
 * Returns the first physician id found for selected appointments, preserving
 * appointment array order so behavior stays deterministic across callers.
 */
export function getSelectedPhysicianIdFromAppointments(
  appointments: PhysicianSelectionAppointment[],
  selectedAppointmentIds: string[],
): string | null {
  if (selectedAppointmentIds.length === 0) {
    return null
  }

  const selectedIds = new Set(selectedAppointmentIds)
  for (const appointment of appointments) {
    if (!selectedIds.has(appointment.id)) {
      continue
    }

    const physicianId = appointment.referrerId
      ?? appointment.referringPhysicianId
      ?? appointment.attendingPhysicianId
      ?? appointment.orderingPhysicianId
      ?? null
    if (physicianId) {
      return physicianId
    }
  }

  return null
}

/**
 * Returns the first physician id found for selected appointments, preserving
 * appointmentOptions order so behavior stays deterministic across callers.
 */
export function getSelectedPhysicianIdFromAppointmentOptions(
  appointmentOptions: AppointmentSelectOption[],
  selectedAppointmentIds: string[],
): string | null {
  return getSelectedPhysicianIdFromAppointments(
    appointmentOptions.map(option => option.appointment),
    selectedAppointmentIds,
  )
}
